import React, { useEffect, useRef, useState } from "react";
import Modal from "@/components/Modal";
import { useTranslation } from "@/langs/useTranslation";
import MemoedHOC from "@/hoc/MemoedHOC";

function TranserModal({ open, onConfirm, onClose }) {
  const { t } = useTranslation();

  useEffect(() => {}, [open]);

  return (
    <Modal
      title={t({ defaultMessage: "移除设备" })}
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      className="StoreUpdateStatusModal"
    >
      <div class="subTitle">
        {t({ defaultMessage: "是否将选择的设备移除？" })}
      </div>
    </Modal>
  );
}

export default MemoedHOC(TranserModal);
